import React from 'react';
import ReactCursorPosition, { INTERACTIONS } from 'react-cursor-position';
import _ from 'lodash';
import Scheme from "./Scheme";
import FileUpload from "../../common/FileUpload";
import PhotoCategory from "./PhotoCategory";

class VehicleApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      points: props.points ? props.points : [],
      x: undefined,
      y: undefined,
      part: undefined,
      width: undefined,
      height: undefined,
      damageType: window.BODY_DAMAGE_TYPES[0].value,
      status: undefined,
      files: props.files ? props.files : [],
      damageFiles: [],
      pointsInputName: props.pointsInputName ? props.pointsInputName : 'doc[body_damages]',
      imagesInputName: props.imagesInputName ? props.imagesInputName : 'doc[images]',
    };
    this.scheme = React.createRef();
    this.rcp = React.createRef();
    this.addPoint = this.addPoint.bind(this);
    this.reset = this.reset.bind(this);
  }

  reset() {
    _.debounce(() => {
        this.rcp.reset();
      }, 250, { loading: false, trailing: true }
    )
  }

  addPoint() {
    const newPointsList = Object.assign([], this.state.points);
    newPointsList.push({
      x: this.state.x,
      y: this.state.y,
      part: this.state.part,
      type: this.state.damageType,
      files: this.state.damageFiles
    });
    this.setState({ points: newPointsList, status: undefined });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    document.getElementsByName(this.props.pointsInputName)[0].value = JSON.stringify(this.state.points);
    document.getElementsByName(this.props.imagesInputName)[0].value = JSON.stringify(this.state.files);
  }

  render() {
    const { status, part } = this.state;
    const minNoOfPhotosPerDamage = window.MIN_NO_OF_PHOTOS_PER_DAMAGE ? parseInt(window.MIN_NO_OF_PHOTOS_PER_DAMAGE) : 2;
    return <div style={{ position: 'relative', overflow: 'auto' }}>
      <div className="grid-x grid-margin-x">
        {_.map(window.PHOTO_CATEGORIES, (cat, id) => (
          <PhotoCategory key={`photo-cat-${id}`} label={cat} files={this.state.files[id]} setFiles={files => {
            const newFiles = {};
            newFiles[id] = files;
            this.setState({ files: Object.assign({}, this.state.files, newFiles) });
          }} />))}
      </div>
      <div style={{ maxWidth: '800px', margin: 'auto', position: 'relative' }} onMouseEnter={this.reset}>
        <ReactCursorPosition activationInteractionTouch={INTERACTIONS.TAP}
                             activationInteractionMouse={INTERACTIONS.CLICK}
                             ref={this.rcp}>
          <Scheme clicked={(x, y, width, height, part) => {
            this.setState({ x, y, part, width, height, status: 'CONFIRM' });
          }} ref={this.scheme} scheme={this.props.scheme} />
        </ReactCursorPosition>
        {_.map(this.state.points, (point, key) => (
          <div key={key}
               style={{
                 position: 'absolute',
                 top: point.y * this.state.height,
                 left: point.x * this.state.width,
                 width: '10px',
                 marginLeft: '-5px',
                 marginTop: '-10px'
               }}>
            <i className="fas fa-thumbtack"></i>
          </div>
        ))}
      </div>
      {status === 'CONFIRM' && <div style={{
        position: 'absolute',
        background: 'black',
        opacity: '0.8',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%'
      }} onClick={() => {
        this.setState({ status: undefined })
      }}></div>}
      {status === 'CONFIRM' && <div style={{
        position: 'absolute',
        background: '#ffffff',
        borderRadius: '5px',
        top: '50%',
        left: '50%',
        width: `${this.state.width > 500 ? 500 : this.state.width}px`,
        marginLeft: `-${this.state.width > 500 ? 250 : (this.state.width / 2)}px`,
        marginTop: '-200px'
      }}>
        <div style={{ padding: '.5em' }}>
          <p>
            Miejsce: <strong>{window.BODY_PARTS[part]}</strong>
          </p>
          <label>
            Rodzaj:
            <select value={this.state.damageType} onChange={e => {
              this.setState({ damageType: e.target.value })
            }}>
              {_.map(window.BODY_DAMAGE_TYPES, (option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))};
            </select>
          </label>
          <div>
            <label>Zdjęcia uszkodzenia:</label>
            <FileUpload updateFileList={files => {
              this.setState({ damageFiles: files });
            }}>
              <p>Załącz co
                najmniej {minNoOfPhotosPerDamage} {minNoOfPhotosPerDamage == 1 ? 'zdjęcie' : 'zdjęcia'} uszkodzonego
                elementu.</p>
            </FileUpload>
          </div>
          <div className="button-group">
            <button className="button"
                    disabled={_.filter(this.state.damageFiles, file => file.status === 'READY').length < minNoOfPhotosPerDamage}
                    onClick={(e) => {
                      e.preventDefault();
                      this.addPoint();
                      return false;
                    }}>OK
            </button>
            <button className="button secondary hollow" onClick={() => {
              this.setState({ status: undefined });
              return false;
            }}>Anuluj
            </button>
          </div>
        </div>
      </div>}
      <ul className="damage-list">
        {this.state.points.map((point, idx) => (
          <li
            key={`point-${idx}`}>
            <strong>{window.BODY_PARTS[point.part]}</strong> -
            ({_.find(window.BODY_DAMAGE_TYPES, t => t.value === point.type).label})
            <a className="button tiny secondary" title="Usuń"
               onClick={() => {
                 const newPointsList = Object.assign([], this.state.points);
                 newPointsList.splice(this.state.points.indexOf(point), 1);
                 this.setState({ points: newPointsList });
               }}>
              <i className="fas fa-trash"></i>
            </a>
          </li>
        ))}
      </ul>
    </div>;
  }
}

export default VehicleApp
